import { render, staticRenderFns } from "./DomainOperate.vue?vue&type=template&id=16280650&scoped=true&"
import script from "./DomainOperate.vue?vue&type=script&lang=js&"
export * from "./DomainOperate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16280650",
  null
  
)

export default component.exports